import axios from "axios"

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['content-type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = '//' + window.location.hostname + '/'

export { axios }
